import { PencilSquareIcon } from '@heroicons/react/24/outline';
import Link from 'components/gruenland/atoms/link';

type EditCTAProps = {
  editHref: string;
};

const EditCTA: React.FC<EditCTAProps> = ({ editHref }) => {
  return (
    <Link link={editHref} className="h-fit">
      <div className="relative grid size-10 place-items-center rounded-full bg-neutral-200 shadow-100">
        <PencilSquareIcon className="absolute size-5 text-secondary-black" />
      </div>
    </Link>
  );
};

export default EditCTA;
